(() => {
  const MAX_LENGTH = 150;
  const NOTE_SELECTOR =
    '[data-essential-cart-element="order-note-textarea"]';
  const COUNTER_SELECTOR =
    '[data-essential-cart-note-counter]';

  function updateCounter(note, counter) {
    const remaining = Math.max(
      0,
      MAX_LENGTH - note.value.length
    );

    counter.textContent = `${remaining} characters remaining`;

    // Red when 20 or fewer characters remain
    if (remaining <= 20) {
      counter.style.color = "#d72c0d";
    } else {
      counter.style.color = "#666666";
    }
  }

  function setupNote(note) {
    if (!note || note.dataset.essentialNoteSetup === "true") {
      return;
    }

    // Limit the field to 150 characters
    note.maxLength = MAX_LENGTH;

    // Create the counter
    const counter = document.createElement("div");

    counter.setAttribute(
      "data-essential-cart-note-counter",
      ""
    );

    counter.style.cssText =
      "font-size:12px;" +
      "line-height:1.4;" +
      "margin-top:4px;" +
      "text-align:right;" +
      "color:#666666;" +
      "transition:color .15s ease;";

    note.insertAdjacentElement("afterend", counter);

    // Update counter while typing
    note.addEventListener("input", () => {
      updateCounter(note, counter);
    });

    note.dataset.essentialNoteSetup = "true";

    // Initial counter
    updateCounter(note, counter);
  }

  function findAndSetupNote() {
    const notes = document.querySelectorAll(NOTE_SELECTOR);

    notes.forEach(setupNote);
  }

  // Initial check
  findAndSetupNote();

  // Watch for the Cart Drawer being opened/rendered
  const observer = new MutationObserver(() => {
    findAndSetupNote();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();